module.exports = __webpack_public_path__ + "img/arToEn.f2d63fc9.png";